// src/hooks/useAppConfig.ts
import { useSelector } from 'react-redux';

export const useAppConfig = (): any | undefined => {
  const settings = useSelector((state: any) => state.configurationSettings.records);
  return settings.length ? settings[0] : undefined;
};
